import React from 'react';

import {InnerTopSectionWrapper, TopSectionWrapper} from '../timesheets.styled';
import {TIME_PERIOD} from '../timesheets_change_date_view';
import TimesheetsCalendar from './TimesheetsCalendar';
import moment from 'moment';

const TimesheetsTopSection = ({
	viewer,
	showCalendar,
	timePeriod,
	setTimePeriod,
	currentViewingDate,
	setCurrentViewingDate,
	currentViewingMonth,
	selectedPerson,
	lockedDate,
	calendarEvents,
	isLoadingCalendarEvents,
	showNewSideModal,
	setClickedCalendarEventId,
	isEventConvertedBySideModal,
}) => {
	const logTimeButton = document.getElementById('add-time-entry-button');
	const buttonBounds = logTimeButton ? logTimeButton.getBoundingClientRect() : null;

	const style = {
		zIndex: 99,
		position: 'absolute',
	};
	if (buttonBounds) {
		style.top = buttonBounds.top + 35;
		style.left = buttonBounds.right - (window.innerWidth > 1400 ? 476 : 446);
	}

	const selectDay = date => {
		setTimePeriod(TIME_PERIOD.DAY_VIEW);
		setCurrentViewingDate(date);
	};

	const selectWeek = date => {
		setTimePeriod(TIME_PERIOD.WEEK_VIEW);
		const todayIsInWeek = date.week() === moment().week();
		// Set CurrentViewingDate to today if today is in the selected week, or the same weekday as what was selected before if not.
		setCurrentViewingDate(todayIsInWeek ? moment() : date.clone().weekday(currentViewingDate.weekday()));
	};

	return (
		<TopSectionWrapper timeRegSideModalOpen={showNewSideModal}>
			{showCalendar ? (
				<InnerTopSectionWrapper>
					<TimesheetsCalendar
						timeRegistrations={viewer.timeRegistrations}
						currentViewingDate={currentViewingDate.toDate()}
						currentViewingMonth={currentViewingMonth.toDate()}
						currentPersonViewed={selectedPerson}
						selectDay={selectDay}
						selectWeek={selectWeek}
						timePeriod={timePeriod}
						calendarEvents={calendarEvents}
						isLoadingCalendarEvents={isLoadingCalendarEvents}
						lockedDate={lockedDate ? lockedDate.toDate() : null}
						calendarTokenError={viewer.calendarIntegrations.googleCalendar.calendarTokenError}
						calendarFetchEnabled={viewer.calendarIntegrations.googleCalendar.calendarFetchEnabled}
						outlookCalendarTokenError={viewer.calendarIntegrations.outlookCalendar.calendarTokenError}
						outlookCalendarFetchEnabled={viewer.calendarIntegrations.outlookCalendar.calendarFetchEnabled}
						showNewSideModal={showNewSideModal}
						setClickedCalendarEventId={setClickedCalendarEventId}
						isEventConvertedBySideModal={isEventConvertedBySideModal}
					/>
				</InnerTopSectionWrapper>
			) : null}
		</TopSectionWrapper>
	);
};

export default TimesheetsTopSection;
